import { SlideComment, SlideCommentChangeSet } from "../../models/SlideComment";
import {
    TempFile,
    FilePreviewImage,
    CreateSlideIF,
    Slide,
    EditSlideIF,
} from "../../models/slides";
import SlideEvent from "../events/SlideEvent";

// コンテンツアップロードでURL生成
export const CreateTempFile = (file: File) =>
    ({
        type: SlideEvent.CreateTempFileStarted,
        file,
    } as const);

export const CreateTempFileComplete = (tempFile: TempFile) =>
    ({
        type: SlideEvent.CreateTempFileComplete,
        tempFile,
    } as const);

// tempファイルのページ総数の取得
export const GetTempPageCount = (keyName: string) =>
    ({
        type: SlideEvent.GetTempPageCountStarted,
        keyName,
    } as const);

export const GetTempPageCountComplete = (pageCount: number) =>
    ({
        type: SlideEvent.GetTempPageCountComplete,
        pageCount,
    } as const);

// tempファイル表示URLの取得
export const GetTempPreviewUrl = (keyName: string, pageNo: number) =>
    ({
        type: SlideEvent.GetTempPreviewUrlStarted,
        keyName,
        pageNo,
    } as const);

export const GetTempPreviewUrlComplete = (previewImage: FilePreviewImage) =>
    ({
        type: SlideEvent.GetTempPreviewUrlComplete,
        previewImage,
    } as const);

// 新規コンテンツ作成
export const CreateNewSlide = (newSlide: CreateSlideIF) =>
    ({
        type: SlideEvent.CreateNewSlideStarted,
        newSlide,
    } as const);

export const CreateNewSlideComplete = () =>
    ({
        type: SlideEvent.CreateNewSlideComplete,
    } as const);

// 新規コンテンツ作成キャンセルでtempファイルの削除
export const DeleteTempFile = (keyName: string) =>
    ({
        type: SlideEvent.DeleteTempFileStarted,
        keyName,
    } as const);

export const DeleteTempFileComplete = (keyName: string) =>
    ({
        type: SlideEvent.DeleteTempFileComplete,
        keyName,
    } as const);

// コンテンツ情報取得
export const GetSlideById = (userId: number, id: number) =>
    ({
        type: SlideEvent.GetSlideByIdStarted,
        userId,
        id,
    } as const);

export const GetSlideByIdComplete = (slide: Slide) =>
    ({
        type: SlideEvent.GetSlideByIdComplete,
        slide,
    } as const);

// コンテンツページ総数の取得
export const GetSlidePageCount = (id: number, fileName: string) =>
    ({
        type: SlideEvent.GetSlidePageCountStarted,
        id,
        fileName,
    } as const);

export const GetSlidePageCountComplete = (pageCount: number) =>
    ({
        type: SlideEvent.GetSlidePageCountComplete,
        pageCount,
    } as const);

// コンテンツ表示URLの取得
export const GetSlidePreviewImageUrl = (id: number, fileName: string, pageNo: number) =>
    ({
        type: SlideEvent.GetSlidePreviewImageUrlStarted,
        id,
        fileName,
        pageNo,
    } as const);

export const GetSlidePreviewImageUrlComplete = (previewImage: FilePreviewImage) =>
    ({
        type: SlideEvent.GetSlidePreviewImageUrlComplete,
        previewImage,
    } as const);

// コンテンツ編集
export const EditSlide = (editSlideInfo: EditSlideIF) =>
    ({
        type: SlideEvent.EditSlideStarted,
        editSlideInfo,
    } as const);

export const EditSlideComplete = (updateSlide: Slide) =>
    ({
        type: SlideEvent.EditSlideComplete,
        updateSlide,
    } as const);

export const EditSlideFailed = () =>
    ({
        type: SlideEvent.EditSlideFailed
    } as const);

// コンテンツ情報リセット処理
export const ResetSlideInfo = () =>
    ({
        type: SlideEvent.ResetSlideInfo,
    } as const);

// コンテンツの削除
export const DeleteSlide = (id: number) =>
    ({
        type: SlideEvent.DeleteSlideStarted,
        id
    } as const);

export const DeleteSlideComplete = (id: number) =>
    ({
        type: SlideEvent.DeleteSlideComplete,
        id
    } as const);

export const DeleteSlideFailed = () =>
    ({
        type: SlideEvent.DeleteSlideFailed
    } as const);

// コメントの追加
export const AddSlideComment = (slideCommentChangeSet: SlideCommentChangeSet) =>
    ({
        type: SlideEvent.AddSlideCommentStarted,
        slideCommentChangeSet,
    } as const);

export const AddSlideCommentComplete = (comment: SlideComment) =>
    ({
        type: SlideEvent.AddSlideCommentComplete,
        comment,
    } as const);

// コメントの編集
export const UpdateSlideComment = (slideCommentChangeSet: SlideCommentChangeSet) =>
    ({
        type: SlideEvent.UpdateSlideCommentStarted,
        slideCommentChangeSet,
    } as const);

export const UpdateSlideCommentComplete = (documentId: number, slideCommentChangeSet: SlideCommentChangeSet) =>
    ({
        type: SlideEvent.UpdateSlideCommentComplete,
        documentId,
        slideCommentChangeSet,
    } as const);

// コメントの削除
export const DeleteSlideComment = (id: number, userId: number, documentId: number) =>
    ({
        type: SlideEvent.DeleteSlideCommentStarted,
        id,
        userId,
        documentId,
    } as const);

export const DeleteSlideCommentComplete = (documentId: number, slideCommentChangeSet: SlideCommentChangeSet) =>
    ({
        type: SlideEvent.DeleteSlideCommentComplete,
        documentId,
        slideCommentChangeSet,
    } as const);

// コメントの返信
export const ReplayToSlideComment = (comment: SlideComment) =>
    ({
        type: SlideEvent.ReplayToSlideCommentStarted,
        comment,
    } as const);

export const ReplayToSlideCommentComplete = (slideCommentChangeSet: SlideCommentChangeSet) =>
    ({
        type: SlideEvent.ReplayToSlideCommentComplete,
        slideCommentChangeSet,
    } as const);